<template>
	<div class="container" id="profile_section">
		<div v-if="user_level < 99">
			<h5 class="text-danger text-center mt-5">Access Denied!</h5>
		</div>

		<div v-else>
			<div class="row gold text-center">
				<div class="col-md-6 col-12">
					<h2>
						<i class="far fa-window-restore pr-1"></i>
						<span v-text="this.$route.meta.title"></span> (<small v-text="totalRows"></small>)
					</h2>
				</div>
				<div class="col-md-6 col-12">
					<button type="button" class="btn btn-sm btn-outline-secondary" @click="cardAdd">
						<i class="far fa-window-maximize"></i> Add New Card
					</button>
				</div>
			</div>

			<b-modal
				id="modal-card"
				:title="modal.title"
				ref="modal-card"
				no-close-on-backdrop
				size="lg"
			>
				<b-form @submit="submitCardForm($event)">
					<b-form-group>
						<small class="text-muted">ID</small>
						<b-form-input
							v-model="modal.card.id"
							type="text"
							readonly
							placeholder="System generated ID"
						></b-form-input>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Status</small>
						<b-form-select
							v-model="modal.card.status"
							:options="statuses"
							@change="validate(modal.card)"
						></b-form-select>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Title</small>
						<b-form-input
							v-model="modal.card.title"
							type="text"
							required
							placeholder="Enter card title"
							@change="validate(modal.card)"
						></b-form-input>
						<small class="text-danger" v-if="modal.card.title === ''">
							Enter a card title
						</small>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Slug</small>
						<b-form-input
							v-model="modal.card.slug"
							type="text"
							required
							placeholder="Unique card ID"
							@change="validate(modal.card)"
						></b-form-input>
						<small class="text-danger" v-if="modal.card.slug === ''">
							Enter a card slug
						</small>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Component</small>
						<b-form-input
							v-model="modal.card.component"
							type="text"
							required
							placeholder="Enter card component"
							@change="validate(modal.card)"
						></b-form-input>
						<small class="text-danger" v-if="modal.card.component === ''">
							Enter a card component
						</small>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Category</small>
						<b-form-input
							v-model="modal.card.category"
							type="text"
							placeholder="Category_slug, comma seperate for multiple"
							@change="validate(modal.card)"
						></b-form-input>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Description</small>
						<b-form-textarea
							v-model="modal.card.description"
							type="text"
							required
							placeholder="Enter card description"
							rows="3"
							max-rows="6"
							@change="validate(modal.card)"
						></b-form-textarea>
						<small class="text-danger" v-if="modal.card.description === ''">
							Enter a card description
						</small>
					</b-form-group>

					<b-form-group>
						<small class="text-muted">Sort Order</small>
						<b-form-input
							v-model="modal.card.sort"
							type="text"
							required
							placeholder="Sort order"
							@change="validate(modal.card)"
						></b-form-input>
						<small class="text-danger" v-if="modal.card.sort === ''">
							Enter a sort order
						</small>
					</b-form-group>

					<b-form-group class="mt-4">
						<small class="text-muted">Meta Data Fields - use as required</small>
						<div v-for="item in modal_card_default.meta_fields" :key="item.id">
							<b-input-group class="mb-1">
								<b-form-input
									v-model="item.id"
									type="text"
									:placeholder="item.placeholder"
									class="col-4"
								></b-form-input>
								<b-form-input
									v-model="item.value"
									type="text"
									:placeholder="item.placeholder"
									class="col-8"
								></b-form-input>
							</b-input-group>
						</div>
					</b-form-group>
				</b-form>

				<p><small class="text-danger" v-text="modal.errors.process"></small></p>

				<template #modal-footer="{ cancel }">
					<div class="w-100 row">
						<div class="col text-left">
							<b-button
								type="button"
								size="md"
								variant="success"
								:disabled="modal.submitDisabled"
								@click="submitCardForm()"
								>Save
							</b-button>
						</div>
						<div class="col text-right">
							<b-button
								size="sm"
								@click="confirmBox()"
								name="delete"
								variant="outline-danger"
								>Delete
							</b-button>
							<b-button size="sm" variant="outline-secondary" @click="cancel('cancel')">
								cancel
							</b-button>
						</div>
					</div>
				</template>
			</b-modal>

			<div class="row" id="card_wrap">
				<div class="col-md-6 my-1">
					<b-form-group class="mb-0">
						<b-input-group size="sm">
							<b-form-input
								id="filter-input"
								v-model="filter"
								type="search"
								placeholder="Search cards"
							></b-form-input>

							<b-input-group-append>
								<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
				</div>

				<div class="col-md-3 col-4 my-1">
					<b-form-group class="mb-0">
						<b-form-select
							id="per-page-select"
							v-model="perPage"
							:options="pageOptions"
							size="sm"
						></b-form-select>
					</b-form-group>
				</div>

				<div class="col-md-3 col-8 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>

				<div class="col-12">
					<b-table
						bordered
						responsive
						:items="cards"
						:busy="isBusy"
						:fields="fields"
						:filter="filter"
						:filter-included-fields="filterOn"
						@filtered="onFiltered"
						:current-page="currentPage"
						:per-page="perPage"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						sort-icon-left
						class="small"
						show-empty
					>
						<template v-slot:table-busy>
							<div class="text-center my-2 p-2">
								<b-spinner class="align-middle"></b-spinner>
								<br />
								<strong>Loading...</strong>
							</div>
						</template>

						<template v-slot:cell(status)="data">
							<span v-text="arrayElmGet(statuses, data.item.status)"></span>
						</template>

						<template v-slot:cell(actions)="data">
							<b-dropdown
								size="sm"
								split
								split-variant="outline-primary"
								class="gold"
								text="Edit"
								@click="cardEdit($event, data.item)"
							>
								<b-dropdown-item>
									<div>
										<a href="#" @click="cardEdit($event, data.item)"> Card data </a>
									</div>
								</b-dropdown-item>
							</b-dropdown>
						</template>
					</b-table>
				</div>

				<div class="col-12 my-1">
					<b-pagination
						v-model="currentPage"
						:total-rows="totalRows"
						:per-page="perPage"
						align="right"
						size="sm"
						class="my-0"
					></b-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'CardsAdmin',
	components: {},
	props: {},
	data() {
		return {
			modal: {
				title: '',
				submitDisabled: true,
				card: {},
				errors: {
					process: '',
				},
			},
			meta_fields: null,
			modal_card_default: {
				id: null,
				title: '',
				component: '',
				sort: 100,
				status: 1,
				meta_fields: null,
			},

			statuses: [
				{ value: 0, text: 'Closed (deleted)' },
				{ value: 1, text: 'Active' },
				{ value: 2, text: 'Pending' },
			],

			errors: {},
			categories: {},
			cards: null,

			fields: [
				{ key: 'actions', sortable: false, label: 'Actions', class: '' },
				{ key: 'title', sortable: true, label: 'Title', class: '' },
				{ key: 'category', sortable: true, label: 'Category', class: '' },
				{ key: 'slug', sortable: true, label: 'Slug', class: '' },
				{ key: 'description', sortable: true, label: 'Description', class: '' },
				{ key: 'status', sortable: true, label: 'Status', class: '' },
				{ key: 'component', sortable: true, label: 'Component', class: '' },
				{ key: 'sort', sortable: true, label: 'Default view order', class: '' },
				{ key: 'id', sortable: true, label: 'ID', class: '' },
			],
			isBusy: true,
			sortBy: 'sort',
			sortDesc: false,
			totalRows: 0,
			currentPage: 1,
			perPage: 50,
			pageOptions: [
				{ value: 50, text: 'Num to Show' },
				25,
				50,
				100,
				{ value: 500, text: 'All' },
			],
			filter: null,
			filterOn: [],
		};
	},
	methods: {
		arrayElmGet(obj, value) {
			const entries = Object.entries(obj);
			for (const v of entries) {
				if (parseInt(v[1].value) === parseInt(value)) {
					return v[1].text;
				}
			}
			return null;
		},
		confirmBox() {
			this.$bvModal
				.msgBoxConfirm('Are you sure you want to delete this Card?')
				.then((value) => {
					if (value == true) {
						this.modal.card.status = 0;
						this.submitCardForm();
					} else {
						this.$bvModal.hide('modal-card');
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length;
			this.currentPage = 1;
		},
		submitCardForm(e) {
			console.log('submitCardForm');

			let _this = this;
			if (e) {
				e.preventDefault();
			}

			_this.modal.errors.process = 'Processing...';

			let params = new URLSearchParams();

			if (_this.modal.card) {
				const obj = Object.entries(_this.modal.card);
				for (const [k, item] of obj) {
					if (k === 'meta_fields') {
						const obj2 = Object.entries(item);
						for (const item2 of obj2) {
							params.append('card[meta_fields][' + item2[1].id + ']', item2[1].value);
						}
					} else {
						params.append('card[' + k + ']', item);
					}
				}
			}

			axios({
				method: 'post',
				url:
					_this.$store.state.api_url +
					'cardsAdminAddEdit?token=' +
					_this.$store.state.session_id,
				data: params,
			})
				.then(function (response) {
					_this.modal.errors.process = response.data.message;

					if (response.data.status == 1) {
						if (response.data.card !== null) {
							_this.cards = Object.values(response.data.cards);
							_this.meta_fields = response.data.fields;
							_this.modal_card_default.meta_fields = response.data.fields;
						}

						_this.totalRows = _this.cards.length;

						_this.$refs['modal-card'].hide();
					} else {
						_this.modal.errors.process = response.data.message;
					}
				})
				.catch(function (e) {
					console.log('Error: submitCardForm:' + e);
				});
		},
		cardAdd() {
			console.log('cardAdd');
			const obj = Object.entries(this.meta_fields);
			for (const [k, v] of obj) {
				console.log(v);
				this.modal_card_default.meta_fields[k].value = null;
			}
			const obj2 = Object.entries(this.modal_card_default);
			for (const [k, v] of obj2) {
				console.log(v);
				if (k !== 'meta_fields') {
					this.modal_card_default[k] = null;
				}
			}
			this.modal.card = this.modal_card_default;
			this.modal.title = 'Add Card';
			this.modal.errors.process = '';

			this.$bvModal.show('modal-card');
			this.validate(this.modal.card);
		},
		cardEdit(e, item) {
			const obj = Object.keys(this.meta_fields);
			for (const k of obj) {
				if (this.modal_card_default.meta_fields[k]) {
					this.modal_card_default.meta_fields[k].value = null;
				}
			}
			this.modal.card = this.modal_card_default;
			if (item) {
				const obj = Object.entries(item);
				for (const [k, v] of obj) {
					if (k === 'meta_fields') {
						const obj2 = Object.entries(v);
						for (const [k2, v2] of obj2) {
							if (this.modal.card.meta_fields[k2]) {
								this.modal.card.meta_fields[k2].value = v2;
							}
						}
					} else {
						this.modal.card[k] = v;
					}
				}
			}

			this.modal.title = 'Edit Card';
			this.modal.errors.process = '';
			this.$bvModal.show('modal-card');
			this.validate(this.modal.card);
		},
		cardsGet() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			axios({
				url: _this.$store.state.api_url + 'cardsAdminGet',
				params: params,
			})
				.then(function (response) {
					_this.isBusy = false;
					if (response.data.status == 1) {
						_this.cards = Object.values(response.data.cards);
						_this.meta_fields = response.data.fields;
						_this.modal_card_default.meta_fields = response.data.fields;
					} else {
						_this.cards = null;
					}
					_this.totalRows = _this.cards.length;
				})
				.catch(function () {
					console.log('Error: cardsGet.');
				});
		},

		validate(item) {
			var valid = true;
			if (item.status === '' || item.status === 'null') {
				valid = false;
			}
			if (item.title === '') {
				valid = false;
			}

			if (valid == true) {
				this.modal.submitDisabled = false;
				return false;
			} else {
				this.modal.submitDisabled = true;
				return true;
			}
		},
	},
	computed: {
		sortOptions() {
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => {
					return { text: f.label, value: f.key };
				});
		},
		active_profile() {
			return this.$store.getters.profileGet;
		},
		user_level() {
			return this.active_profile.level;
		},
	},
	created() {},
	mounted() {
		this.cardsGet();
	},
	watch: {},
};
</script>
